import React, { Component } from 'react'
import { Link, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { Field, reduxForm, getFormValues } from 'redux-form'
import agent from '../agent'

import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';

import Modal from 'react-responsive-modal';

import Back from "../components/Back";
import Svg from '../components/Svg';
import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';

import Background from '../assets/images/stock1.jpg'


const Header = ({title, subtitle}) => {
	return (
		<section id="brand-logo" className="section-brand-logo section">
		  <div className="row">
		  <div className="small-12 small-centered column text-center forgot">
		  	<div className="header-image-container">
			  	<img className="am-logo" src={AMLogo} alt="" />
		  	</div>
		    <p className="top-title sub-title-1"><b>{title}</b></p>
		    <p className="top-title sub-title-2">{subtitle}</p>
		  </div>
		  </div>
		</section>
	)
}
const ShowEmailText = ({handleSubmit, errors, handleChange}) => {
	return (
		<section id="artist-login" className="section-artist-login gray-bg section">
			<div className="row">
			<div className="small-12 small-centered column text-center">

					<Back />
					
					<h2>PLEASE ENTER YOUR EMAIL ADDRESS BELOW</h2>
					<h6 className="subheader">SO WE CAN SEND YOU A LINK TO RESET YOUR PASSWORD</h6>
				
					<div className="row">
						<div className="small-12 medium-6 large-6 small-centered column">
							<form className="form-margin" id="artist-login-form" onSubmit={ values => handleSubmit(values)}>
							{
								errors && <p className="error-message"><i className="fa fa-exclamation-circle"></i> {errors}</p> 
							}
							<div className="input-group input-margin">
					      		<span className="input-group-label">
					      			<i className="fa fa-envelope-o"></i>
					      		</span>
						      	<Field 
						      		className="input-group-field" 
						      		name="username" 
						      		component="input" 
						      		type="text" 
						      		onChange={handleChange}
						      		placeholder="Email address" />
					    	</div>

							<button 
								className="button primary forgot-button" 
								type="submit">
								RESET NOW
							</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
const ThankYou = ({title, subtitle}) => {
	return (
		<section id="artist-login" className="section-artist-login gray-bg section">
			<div className="row">
				<div className="small-12 small-centered column text-center">
					<h2 className="thank-you-header">{title}</h2>
					<h6 className="subheader thank-you-sub">{subtitle}</h6>
					<Link className="button forgot-button"
						to={{
                            pathname: '/'
                        }}>RETURN TO LOGIN</Link>
				</div>
			</div>
		</section>
	)
}

const ForgotPasswordForm = ({handleSubmit, handlePwChange, handlePwcChange, errors}) => {
	return (
		<section id="artist-login" className="section-artist-login gray-bg section">
			<div className="row">
			<div className="small-12 small-centered column text-center">

					<Back />
					
					<h2>PLEASE ENTER YOUR NEW PASSWORD BELOW</h2>
					<h6 className="subheader">ENTER IT TWICE TO CONFIRM & BE SURE TO MAKE IT SECURE</h6>
					<p className="forgot-tips">TIP GET CREATIVE - 8 DIGITS MINIMUM, IDEALLY WITH A COMBINATION OF UPPER AND LOWERCASE LETTERS, NUMBERS & SPECIAL CHARACTERS</p>

					<div className="row">
						<div className="small-12 medium-6 large-6 small-centered column">
							<form className="form-margin" id="artist-login-form" onSubmit={ handleSubmit }>
							{
								errors && <p className="error-message"><i className="fa fa-exclamation-circle"></i> {errors}</p> 
							}
							<div className="input-group">
					      		<span className="input-group-label">
					      			<Svg iconName="icon-mobile-password" />
					      		</span>
						      	<Field 
						      		className="input-group-field" 
						      		name="password" 
						      		component="input" 
						      		type="password"
						      		onChange={handlePwChange}
						      		placeholder="New Password" />
					    	</div>
					    	<div className="input-group input-margin">
					      		<span className="input-group-label">
					      			<Svg iconName="icon-mobile-password" />
					      		</span>
						      	<Field 
						      		className="input-group-field" 
						      		name="repassword" 
						      		component="input" 
						      		type="password" 
						      		onChange={handlePwcChange}
						      		placeholder="Re-enter Password" />
					    	</div>

							<button 
								className="button primary forgot-button" 
								type="submit">
								RESET NOW
							</button>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}


class ForgotPassword extends Component {
	state = { 
		toggleThankYou: false,
		toggleLoading: true,
		step: 1,
		pulled_user: null,
		email: '',
		password: '',
		password_confirmation: '',
		errors: ''
	}

	componentWillMount() {
		const { location } = this.props
		const passwordToken = new URLSearchParams(location.search).get('token');

		if (passwordToken != null && passwordToken.length > 0) {
			agent.Client.pullUser(passwordToken).then( user => {
				if (user != null && user.user != null)
					this.setState({pulled_user: user.user})
				else
					this.setState({toggleLoading: false})
			})
		} else {
			this.setState({toggleLoading: false})
		}


	}

  someSubmit = (event) => {
  	event.preventDefault()
  	agent.Client.requestPasswordChange(this.state.email.toLowerCase())
  	this.setState({ toggleThankYou: true })
	}

	handleChange = (event) => {
		this.setState({email: event.target.value})
	}

	handlePwChange = (event) => {
		this.setState({password: event.target.value})
	}

	handlePwcChange = (event) => {
		this.setState({password_confirmation: event.target.value})
	}

	onFinalize = (values) => {
		values.preventDefault()
		const { location } = this.props
  	const passwordToken = new URLSearchParams(location.search).get('token');

  	if (this.state.password != this.state.password_confirmation) {
  		this.setState({errors: "Passwords don't match"})
  		return
  	}

  	if (this.state.password.length < 8) {
  		this.setState({errors: "Password is too short"})
  		return
  	}

  	this.setState({
  		toggleThankYou: true,
  		step: 2
  	})

  	agent.Client.changePassword({password_token: passwordToken, password: this.state.password, password_confirmation: this.state.password_confirmation})
  	
	}

	render() {
		const { location, errors, clientToken } = this.props
		const { projectId } = this.state
		console.log('render', this.state.toggleThankYou)

		const passwordToken = new URLSearchParams(location.search).get('token');

		const style = {
			backgroundImage: `url(${Background})`,
			backgroundSize: 'cover'
		}
			
		return (
			<Aux>
				{ <Header title={this.state.step == 1 ? "So you forgot your password ?" : "Password Reset Page"}
						subtitle={this.state.step == 1 ? "All good it happens, we can help !" : "OK, last step we are close now."} />
				}
				{
					this.state.toggleThankYou ?
						<ThankYou title={this.state.step == 1 ? "THANK YOU, HELP IS ON ITS WAY !" : "THANK YOU, YOU ARE DONE"} 
								subtitle={this.state.step == 1 ? "PLEASE CHECK YOUR EMAIL NOW" : "DO YOU HAVE IT WRITTEN DOWN SOMEWHERE SO YOU REMEMBER IT ?"} /> : 
						this.state.pulled_user &&
							<ForgotPasswordForm errors={this.state.errors} handlePwChange={this.handlePwChange} handlePwcChange={this.handlePwcChange} handleSubmit={this.onFinalize} />
				}
				{
					!this.state.toggleLoading && !this.state.toggleThankYou &&
						<ShowEmailText errors={errors} handleSubmit={this.someSubmit} handleChange={this.handleChange}/>
				}
			</Aux>
		)
	}
}

ForgotPassword = reduxForm({
  form: 'forgotPasswordForm', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(ForgotPassword)

const mapStateToProps = state => ({
	...state.auth,
	...state.common
})

const mapDispatchToProps = dispatch => ({
	
})

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword)


// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js